// Spanish first, then English, Français and Deutsch (docs/PLAN.md: the product is multilingual). Every
// text exists in all four (locales/complete.test.ts checks it), so the fallback is only a safety net.
// Before sign-in, the language chosen on the public website (?lang= in the link to log in) or else the
// browser's preference decides; afterwards the user's `locale`. Nothing is stored in the browser.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { de } from './locales/de';
import { en } from './locales/en';
import { es } from './locales/es';
import { fr } from './locales/fr';
import { pickLocale } from './util';

export type Locale = 'es' | 'en' | 'fr' | 'de';
export const LOCALES: Locale[] = ['es', 'en', 'fr', 'de'];
/** Each language in its own language, as the public website lists them. */
export const LANGUAGE_NAMES: Record<Locale, string> = {
  es: 'Español',
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
};

export function detectLocale(): Locale {
  return pickLocale(window.location.search, navigator.languages ?? [navigator.language], LOCALES, 'es');
}

void i18n.use(initReactI18next).init({
  resources: {
    es: { translation: es },
    en: { translation: en },
    fr: { translation: fr },
    de: { translation: de },
  },
  lng: detectLocale(),
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

document.documentElement.lang = i18n.language;
i18n.on('languageChanged', (lang) => {
  document.documentElement.lang = lang;
});

export default i18n;
